import React from 'react';

const GripIcon = ({ className = "" }) => (
  <svg className={className} width="12" height="7" viewBox="0 0 17 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.4688 2.4375H0.53125C0.239062 2.4375 0 2.19844 0 1.90625V0.84375C0 0.551562 0.239062 0.3125 0.53125 0.3125H16.4688C16.7609 0.3125 17 0.551562 17 0.84375V1.90625C17 2.19844 16.7609 2.4375 16.4688 2.4375ZM16.4688 6.6875H0.53125C0.239062 6.6875 0 6.44844 0 6.15625V5.09375C0 4.80156 0.239062 4.5625 0.53125 4.5625H16.4688C16.7609 4.5625 17 4.80156 17 5.09375V6.15625C17 6.44844 16.7609 6.6875 16.4688 6.6875Z" fill="#A5B2D3"/>
  </svg>
)

export default GripIcon;
